const isVoid = item => item === undefined || item === 'undefined' || item === null || item === '';

export { isVoid };
